var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import * as PIXI from "pixi.js";
import { registerPixiComponent } from "../ComponentRegistry.js";
import { R as RadiusSchema } from "../../Radius-89a665f8.js";
import { T as TransformSchema } from "../../Transform-9450b7b5.js";
import "../../decorators/type.js";
import "ajv";
import "../../utils/clone.js";
import "bitecs";
import "../../utils/typehelpers.js";
import "../../enums-86f58524.js";
import "../../global-33d5eebf.js";
import "../types.js";
import "../../utils/byteArray.js";
class DebugRadiusDraw {
  constructor() {
    __publicField(this, "ids", /* @__PURE__ */ new Set());
    __publicField(this, "entities", {});
    __publicField(this, "debug", true);
  }
  init(entity, gameModel, viewport) {
    const container = new PIXI.Container();
    container.zIndex = 100;
    RadiusSchema.id = entity;
    const radius = RadiusSchema.radius;
    const radiusGraphic = new PIXI.Graphics();
    radiusGraphic.lineStyle(5, 16711680);
    radiusGraphic.drawCircle(0, 0, radius);
    container.addChild(radiusGraphic);
    container.zIndex = 1e5;
    const entityObj = {
      container,
      radiusGraphic
    };
    viewport.addChild(container);
    this.entities[entity] = entityObj;
    this.ids.add(entity);
  }
  run(entity, gameModel) {
    const transformSchema = gameModel.getTypedUnsafe(entity, TransformSchema);
    const entityPosition = transformSchema.position;
    const container = this.entities[entity].container;
    container.position.set(entityPosition.x, entityPosition.y);
  }
  cleanup(entity) {
    if (!this.entities[entity]) {
      return;
    }
    const container = this.entities[entity].container;
    container.children.forEach((child) => {
      container.removeChild(child);
      child.destroy();
    });
    container.destroy();
    delete this.entities[entity];
    this.ids.delete(entity);
  }
}
registerPixiComponent("Radius", DebugRadiusDraw);
//# sourceMappingURL=Radius.js.map
